/**
 * Rutas Biomax > Seguridad (usuarios, permisos, roles).
 * Entrada: dashboard; el resto desde el menú.
 */
const biomaxRoutes = [
  {
    path: "/Biomax/Dashboard",
    name: "BiomaxDashboard",
    component: () => import("../views/biomax/BiomaxDashboard.vue"),
  },
  {
    path: "/Biomax",
    name: "Biomax",
    redirect: { name: "BiomaxDashboard" },
  },
  {
    path: "/Biomax/Usuarios",
    name: "/Biomax/Usuarios",
    component: () => import("../views/biomax/seguridad/usuarios/UsuarioIndex.vue"),
  },
  {
    path: "/Biomax/Seguridad/Usuarios",
    name: "Biomax/Seguridad/Usuarios",
    component: () => import("../views/biomax/seguridad/usuarios/UsuarioIndex.vue"),
  },
  {
    path: "/Biomax/Seguridad/UsuarioForm",
    name: "Biomax/Seguridad/UsuarioForm",
    component: () => import("../views/biomax/seguridad/usuarios/UsuarioForm.vue"),
  },
  {
    path: "/Biomax/Permisos",
    name: "/Biomax/Permisos",
    component: () => import("../views/biomax/seguridad/permisos/PermisoIndex.vue"),
  },
  {
    path: "/Biomax/Seguridad/Permisos",
    name: "Biomax/Seguridad/Permisos",
    component: () => import("../views/biomax/seguridad/permisos/PermisoIndex.vue"),
  },
  {
    path: "/Biomax/Roles",
    name: "/Biomax/Roles",
    component: () => import("../views/biomax/seguridad/roles/RolIndex.vue"),
  },
  {
    path: "/Biomax/Seguridad/Roles",
    name: "Biomax/Seguridad/Roles",
    component: () => import("../views/biomax/seguridad/roles/RolIndex.vue"),
  },
  // Flota Biomax
  {
    path: "/Biomax/Flota/Documentos",
    name: "/Biomax/Flota/Documentos",
    component: () => import("../views/biomax/flota/documentos/DocumentoIndex.vue"),
  },
  {
    path: "/Biomax/Flota/PaquetesDocs",
    name: "/Biomax/Flota/PaquetesDocs",
    component: () => import("../views/biomax/flota/paquetesDoc/PaqueteDocumentoIndex.vue"),
  },
  {
    path: "/Biomax/Flota/TiposVehiculos",
    name: "/Biomax/Flota/TiposVehiculos",
    component: () => import("../views/biomax/flota/tiposVehiculo/TipoVehiculoIndex.vue"),
  },
  {
    path: "/Biomax/Flota/Vehiculos",
    name: "/Biomax/Flota/Vehiculos",
    component: () => import("../views/biomax/flota/vehiculos/VehiculoIndex.vue"),
  },
  {
    path: "/Biomax/Flota/Remolques",
    name: "/Biomax/Flota/Remolques",
    component: () => import("../views/biomax/flota/remolques/RemolqueIndex.vue"),
  },
  {
    path: "/Biomax/Flota/Conductores",
    name: "/Biomax/Flota/Conductores",
    component: () => import("../views/biomax/flota/conductores/ConductorIndex.vue"),
  },
  // Formularios Flota (desde Biomax > Flota al hacer Editar/Crear)
  {
    path: "/Sos/Admin/Administracion/PaquetesDocsForm",
    name: "/Sos/Admin/Administracion/PaquetesDocsForm",
    component: () => import("../views/sos/admin/administracion/paquetesDoc/PaqueteDocumentoForm.vue"),
  },
  {
    path: "/Sos/Admin/Administracion/VehiculosForm",
    name: "/Sos/Admin/Administracion/VehiculosForm",
    component: () => import("../views/sos/admin/flota/vehiculos/VehiculoForm.vue"),
  },
  {
    path: "/Sos/Admin/Administracion/RemolquesForm",
    name: "/Sos/Admin/Administracion/RemolquesForm",
    component: () => import("../views/sos/admin/flota/remolques/RemolqueForm.vue"),
  },
  {
    path: "/Sos/Admin/Administracion/ConductorForm",
    name: "/Sos/Admin/Administracion/ConductorForm",
    component: () => import("../views/sos/admin/flota/conductores/ConductorForm.vue"),
  },
  {
    path: "/Sos/Admin/Administracion/TiposVehiculosForm",
    name: "/Sos/Admin/Administracion/TiposVehiculosForm",
    component: () => import("../views/sos/admin/flota/tiposVehiculo/TipoVehiculoForm.vue"),
  },
  // Gestiones > Programaciones (Biomax)
  {
    path: "/Biomax/Gestion/Programaciones",
    name: "/Biomax/Gestion/Programaciones",
    component: () => import("../views/biomax/gestion/programaciones/ProgramacionIndex.vue"),
  },
  {
    path: "/Biomax/Gestion/ProgramacionForm/:id",
    name: "/Biomax/Gestion/ProgramacionForm",
    component: () => import("../views/biomax/gestion/programaciones/ProgramacionForm.vue"),
  },
  // Gestiones > Postulaciones (Biomax)
  {
    path: "/Biomax/Gestion/Postulaciones",
    name: "/Biomax/Gestion/Postulaciones",
    component: () => import("../views/biomax/gestion/postulaciones/PostulacionesIndex.vue"),
  },
  // Gestiones > Postulados (Biomax - vista admin)
  {
    path: "/Biomax/Gestion/Postulados",
    name: "/Biomax/Gestion/Postulados",
    component: () => import("../views/biomax/gestion/postulaciones/PostuladosIndex.vue"),
  },
  // Gestiones > Información (Biomax - consulta)
  {
    path: "/Biomax/Gestion/Informacion",
    name: "/Biomax/Gestion/Informacion",
    component: () => import("../views/biomax/gestion/postulaciones/InformacionIndex.vue"),
  },
      // Gestiones > Portería (Biomax - viajes)
      {
        path: "/Biomax/Gestion/Porteria",
        name: "/Biomax/Gestion/Porteria",
        component: () => import("../views/biomax/gestion/porteria/PorteriaIndex.vue"),
      },
  // Admin Biomax (geocercas, paises, ciudades, departamentos, sitios, rutas, empresas)
  {
    path: "/Biomax/Admin/Geocercas",
    name: "/Biomax/Admin/Geocercas",
    component: () => import("../views/biomax/admin/geocercas/GeocercaIndex.vue"),
  },
  {
    path: "/Biomax/Admin/Paises",
    name: "/Biomax/Admin/Paises",
    component: () => import("../views/biomax/admin/paises/PaisIndex.vue"),
  },
  {
    path: "/Biomax/Admin/Ciudades",
    name: "/Biomax/Admin/Ciudades",
    component: () => import("../views/biomax/admin/ciudades/CiudadIndex.vue"),
  },
  {
    path: "/Biomax/Admin/Departamentos",
    name: "/Biomax/Admin/Departamentos",
    component: () => import("../views/biomax/admin/departamentos/DepartamentoIndex.vue"),
  },
  {
    path: "/Biomax/Admin/Sitios",
    name: "/Biomax/Admin/Sitios",
    component: () => import("../views/biomax/admin/sitios/SitioIndex.vue"),
  },
  {
    path: "/Biomax/Admin/Rutas",
    name: "/Biomax/Admin/Rutas",
    component: () => import("../views/biomax/admin/rutas/RutaIndex.vue"),
  },
  {
    path: "/Biomax/Admin/Empresas",
    name: "/Biomax/Admin/Empresas",
    component: () => import("../views/biomax/admin/empresas/EmpresaIndex.vue"),
  },
  // Formularios y PivotTable Admin (Sitios, Rutas, Empresas, Geocercas) — usados por name desde Biomax
  {
    path: "/Sos/Admin/Administracion/SitiosForm",
    name: "/Sos/Admin/Administracion/SitiosForm",
    component: () => import("../views/sos/admin/administracion/sitios/SitioForm.vue"),
  },
  {
    path: "/Sos/Admin/Administracion/RutaForm",
    name: "/Sos/Admin/Administracion/RutaForm",
    component: () => import("../views/sos/admin/administracion/rutas/RutaForm.vue"),
  },
  {
    path: "/Sos/Admin/Administracion/EmpresasForm",
    name: "/Sos/Admin/Administracion/EmpresasForm",
    component: () => import("../views/sos/admin/administracion/empresas/EmpresaForm.vue"),
  },
  {
    path: "/Sos/Admin/Administracion/EmpresaPivotTable",
    name: "/Admin/EmpresaPivotTable",
    component: () => import("../views/sos/admin/administracion/empresas/EmpresaPivotTable.vue"),
  },
  {
    path: "/Sos/Admin/Administracion/GeocercasForm",
    name: "/Sos/Admin/Administracion/GeocercasForm",
    component: () => import("../views/sos/admin/administracion/geocercas/GeocercaForm.vue"),
  },
  {
    path: "/Sos/Admin/Administracion/GeocercasPivotTable",
    name: "/Sos/Admin/Administracion/GeocercasPivotTable",
    component: () => import("../views/sos/admin/administracion/geocercas/GeocercaPivotTable.vue"),
  },
  // Fallback: si el menú generó /Biomax/Biomax/... (ruta relativa), que siga mostrando contenido
  {
    path: "/Biomax/Biomax/Seguridad/Usuarios",
    redirect: "/Biomax/Seguridad/Usuarios",
  },
  {
    path: "/Biomax/Biomax/Seguridad/Permisos",
    redirect: "/Biomax/Seguridad/Permisos",
  },
  {
    path: "/Biomax/Biomax/Seguridad/Roles",
    redirect: "/Biomax/Seguridad/Roles",
  },
  {
    path: "/Biomax/Biomax/Flota/Vehiculos",
    redirect: "/Biomax/Flota/Vehiculos",
  },
  {
    path: "/Biomax/Biomax/Flota/Remolques",
    redirect: "/Biomax/Flota/Remolques",
  },
  {
    path: "/Biomax/Biomax/Flota/Conductores",
    redirect: "/Biomax/Flota/Conductores",
  },
  {
    path: "/Biomax/Biomax/Flota/Documentos",
    redirect: "/Biomax/Flota/Documentos",
  },
  {
    path: "/Biomax/Biomax/Flota/PaquetesDocs",
    redirect: "/Biomax/Flota/PaquetesDocs",
  },
  {
    path: "/Biomax/Biomax/Flota/TiposVehiculos",
    redirect: "/Biomax/Flota/TiposVehiculos",
  },
  {
    path: "/Biomax/Biomax/Admin/Geocercas",
    redirect: "/Biomax/Admin/Geocercas",
  },
  {
    path: "/Biomax/Biomax/Admin/Paises",
    redirect: "/Biomax/Admin/Paises",
  },
  {
    path: "/Biomax/Biomax/Admin/Ciudades",
    redirect: "/Biomax/Admin/Ciudades",
  },
  {
    path: "/Biomax/Biomax/Admin/Departamentos",
    redirect: "/Biomax/Admin/Departamentos",
  },
  {
    path: "/Biomax/Biomax/Admin/Sitios",
    redirect: "/Biomax/Admin/Sitios",
  },
  {
    path: "/Biomax/Biomax/Admin/Rutas",
    redirect: "/Biomax/Admin/Rutas",
  },
  {
    path: "/Biomax/Biomax/Admin/Empresas",
    redirect: "/Biomax/Admin/Empresas",
  },
  {
    path: "/Biomax/Biomax/Gestion/Programaciones",
    redirect: "/Biomax/Gestion/Programaciones",
  },
  {
    path: "/Biomax/Biomax/Gestion/Postulaciones",
    redirect: "/Biomax/Gestion/Postulaciones",
  },
  {
    path: "/Biomax/Biomax/Gestion/Postulados",
    redirect: "/Biomax/Gestion/Postulados",
  },
  {
    path: "/Biomax/Biomax/Gestion/Informacion",
    redirect: "/Biomax/Gestion/Informacion",
  },
  {
    path: "/Biomax/Biomax/Gestion/Porteria",
    redirect: "/Biomax/Gestion/Porteria",
  },
];

export default biomaxRoutes;
